import React from 'react'
import NpsRating from './NpsRating'
import NpsRadio from './NpsRadio'

import './nps-rating.css'

const Embedded = (props) => {
  const thumbnailType = {
    monster: <NpsRadio {...props} />,
    star: <NpsRating {...props} />,
    heart: <NpsRating {...props} />,
    funny_face: <NpsRadio {...props} />,
    outlined: <NpsRadio {...props} />,
    flat_face: <NpsRadio {...props} />,
  }
  return <div>{thumbnailType[props.thumbnail_type]}</div>
}

export default Embedded
